<template>
    <UiModal :is-open="show" :title="title" @close="cancelAction()" :icon :iconColor>
        <template #title>
            <slot name="title"></slot>
        </template>
        <template #content>
            <p class="text-primary text-md font-normal leading-5 font-inter text-slate-800">{{ dialog }}</p>
        </template>
        <template #footer>
            <div class="flex justify-end items-center gap-4">
                <button
                    v-for="button in buttons"
                    :key="button"
                    type="button"
                    class="btn"
                    :class="
                        (button.type === 'cancel'
                            ? 'btn-secondary'
                            : 'btn-primary') + ' ' + button.classes
                    "
                    @click="
                        button.type === 'cancel'
                            ? cancelAction()
                            : confirmAction(button.value)
                    "
                >
                    {{ button.text }}
                </button>
            </div>
        </template>
    </UiModal>
</template>
<script setup>
import UiModal from '@/components/ui/modal/ui-modal.vue';

const emit = defineEmits(['cancel', 'confirm']);

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
    },
    dialog: {
        type: String,
    },
    classes: {
        type: String,
        default: '',
    },
    icon: {
        type: String,
        default: '',
    },
    iconColor: {
        type: String,
        default: 'slate',
    },
    buttons: {
        type: Object,
        default: () => {
            return [
                {
                    type: 'cancel',
                    text: 'Cancel',
                },
                {
                    type: 'confirm',
                    text: 'Confirm',
                    value: true,
                },
            ];
        },
    },
});

const cancelAction = () => {
    emit('cancel');
};

const confirmAction = (value) => {
    emit('confirm', value);
};
</script>
